<template>
    <div id='index'>
        <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/home.jpg')">
            <div class="container">
                <div class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <div class="brand text-center">
                    <h1 class="title">塑膠模具智慧製造領航者</h1>
                    <!-- <h3 class="title text-center">Top R&D Center for Smart Manufacturing</h3> -->
                    <h3 class="title description">Top R&D Center for Smart Manufacturing</h3>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="main main-raised">
            <div class="container">
                <!-- <div class="section text-center"> -->
                <div class="section">
                    <div style="text-justify: distribute; text-align:justify; text-justify:inter-ideograph;">
                        <h3 class="title" style="line-height:40px;">
                            <div style="line-height:170%; font-size:190%; float:left; margin-right:3px;">中</div>原大學智慧製造研發中心為一多功能研發中心，
                            針對模具與射出成型產業，從模具設計、加工、組裝至成型，打造專屬智慧製造解決方案。
                            在塑膠產品開發的生命週期中，從設計、製造到生產之製程複雜，加上現今產品幾何多變、模具加工製程複雜，
                            每個階段的資訊環環相扣管理難度高，穩定地製作出高精密與高品質的模具與產品，是目前模具業的一大挑戰，
                            另外，在模具產業中，大多還是靠老師傅的經驗在解決問題，如何透過學理化的整合，提高模具業的附加價值，是另外一個重要的課題。
                            為了提升模具產業的競爭力，必須將週期中各領域的專業知識技術，以數位化、智能化與物聯網為依據，做水平與垂直的點線面整合，
                            透過整合跨單位資源，建立知識化高值化數位平台，縮短技術發展與產品開發的時程，提升成型品的品質與企業的價值。
                        </h3>
                        <br>
                        <h3>
                            The R&D Center for Smart Manufacturing is a multifunctional center which included smart manufacturing turn-key solution development, talent cultivation program, and academic-industrial cooperation service, etc.
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/index.vue